import { Injectable } from '@angular/core';
import { IGlobalSearchModelData } from '@pflegix/types';

const SEARCH_HISTORY_KEY = 'global_search_history';
const MAX_HISTORY_ITEMS = 10;

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchHistoryService {
  public getSearchHistory(): IGlobalSearchModelData[] {
    const history = localStorage.getItem(SEARCH_HISTORY_KEY);

    return history ? JSON.parse(history) : [];
  }

  public addToHistory(searchResult: IGlobalSearchModelData): void {
    let history = this.getSearchHistory();

    // Remove if already exists to avoid duplicates
    history = history.filter((item) => JSON.stringify(item) !== JSON.stringify(searchResult));

    // Add to beginning of array
    history.unshift(searchResult);

    // Keep only the last 10 items
    if (history.length > MAX_HISTORY_ITEMS) {
      history = history.slice(0, MAX_HISTORY_ITEMS);
    }

    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
  }

  public deleteFromHistory(item: IGlobalSearchModelData): void {
    let history = this.getSearchHistory();

    history = history.filter((historyItem) => JSON.stringify(historyItem) !== JSON.stringify(item));
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
  }

  public clearHistory(): void {
    localStorage.removeItem(SEARCH_HISTORY_KEY);
  }
}
